import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { accountTypes } from "../../Types";
import ValidationError from "../../ZodError";
const operationalStates = ["Pending", "Planning", "Open"];
const zAccountType = z.enum([...accountTypes, "Rollover IRA", "Other"]);
const zOperationalState = z.enum(operationalStates);
const _zCollateralAccount = z.object({
    virtualAccountId: z.string(),
    physicalAccountId: z.string(),
    accountType: zAccountType,
    operationalState: zOperationalState,
    custodianAccountNumber: z.string(),
});
const zCollateralAccountRes = z.object({
    virtualAccountId: z.string(),
    physicalAccountId: z.string(),
    accountType: zAccountType,
    operationalState: zOperationalState,
    custodianAccountNumber: z.string().nullable(),
});
const zGetCollateralAccountsRes = z.array(zCollateralAccountRes);
export const url = (clientId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/dashboard/client/${clientId}/collateral-account`
        : `https://middleware.uat.farther.com/dashboard/client/${clientId}/collateral-account`;
};
export default async function getCollateralAccounts(clientId, config) {
    const { data } = await axios.get(url(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: clientId,
            Advisor: config.advisorId,
        },
    });
    const decoded = zGetCollateralAccountsRes.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getCollateralAccounts] Could not parse`;
        errorLog("getCollateralAccounts", `${decoded.error.message} ${JSON.stringify(decoded.error.issues)}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getCollateralAccount.js.map